import React, { useEffect, useState } from 'react';
import Navigation from './Navigation';
import "./Pl.css"
import { FaPlay } from 'react-icons/fa';

const Inv = () => {
  const [activeButton, setActiveButton] = useState('video');
  const [mainSrc, setMainSrc] = useState('assets/inv1.mp4');
  const [isVideo, setIsVideo] = useState(true);
  const [plotsLeft, setPlotsLeft] = useState(34);

  useEffect(() => {
    document.body.classList.add('bg-white');

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateNumber();
          observer.unobserve(entry.target); // Stop observing after animation starts
        }
      });
    });

    observer.observe(document.querySelector('.number'));

    function animateNumber() {
      const startValue = 920;
      const endValue = 626;
      const duration = 4000;
      const stepTime = Math.abs(Math.floor(duration / (startValue - endValue)));

      let currentValue = startValue;

      const step = () => {
        setPlotsLeft(currentValue);
        if (currentValue > endValue) {
          currentValue--;
          setTimeout(step, stepTime);
        }
      };

      step();
    }

    return () => observer.disconnect(); // Cleanup observer on unmount
  }, []);

  const handleThumbnailClick = (type, src) => {
    setIsVideo(type === 'video');
    setMainSrc(src);
  };

  const handleButtonClick = (button) => {
    setActiveButton(button);
    setIsVideo(button === 'video');
    setMainSrc(button === 'video' ? 'assets/inv1.mp4' : 'assets/invinfra.jpg');
  };

  return (
    <>
      <Navigation />

      <div className="primel">
        <div className="pvheading">
          <button
            id="videoBtn"
            className={`button ${activeButton === 'video' ? 'active' : ''}`}
            onClick={() => handleButtonClick('video')}
          >
            Videos
            <div className="line"></div>
            <div className="line"></div>
          </button>
          <button
            id="photoBtn"
            className={`button ${activeButton === 'photo' ? 'active' : ''}`}
            onClick={() => handleButtonClick('photo')}
          >
            Photos
            <div className="line"></div>
            <div className="line"></div>
          </button>
        </div>

        <div className="main-slider-container">
          <div className="main-slider">
            {isVideo ? (
              <video id="mainVideo" src={mainSrc} controls autoPlay muted playsInline />
            ) : (
              <img id="mainPhoto" src={mainSrc} alt="Main Photo" />
            )}
          </div>
        </div>

        {activeButton === 'video' ? (
          <div className="thumbnail-container video-thumbnails">

            <div className="thumbnail-wrapper">
              <img
                className="thumbnail"
                data-type="video"
                src="assets/invinfra.jpg"
                alt="Video 1"
                onClick={() => handleThumbnailClick('video', 'assets/inv1.mp4')}
              />
              <i className="fa-solid fa-play play-icon">
              <FaPlay/>
              </i>
            </div>

            <div className="thumbnail-wrapper">
              <img
                className="thumbnail"
                data-type="video"
                src="assets/invgate.jpg"
                alt="Video 2"
                onClick={() => handleThumbnailClick('video', 'assets/inv2.mp4')}
              />
              <i className="fa-solid fa-play play-icon">
              <FaPlay/>
              </i>
            </div>

            <div className="thumbnail-wrapper">
              <img
                className="thumbnail"
                data-type="video"
                src="assets/invgolf.jpg"
                alt="Video 3"
                onClick={() => handleThumbnailClick('video', 'assets/inv3.mp4')}
              />
              <i className="fa-solid fa-play play-icon">
              <FaPlay/>
              </i>
            </div>
            
          </div>
        ) : (
          <div className="thumbnail-container photo-thumbnails">
            <img
              className="thumbnail"
              data-type="photo"
              src="assets/invgate.jpg"
              alt="Photo 1"
              onClick={() => handleThumbnailClick('photo', 'assets/invgate.jpg')}
            />
            <img
              className="thumbnail"
              data-type="photo"
              src="assets/invgolf.jpg"
              alt="Photo 2"
              onClick={() => handleThumbnailClick('photo', 'assets/invgolf.jpg')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/invgym.jpg"
              alt="Photo 2"
              onClick={() => handleThumbnailClick('photo', 'assets/invgym.jpg')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/invinfra.jpg"
              alt="Photo 2"
              onClick={() => handleThumbnailClick('photo', 'assets/invinfra.jpg')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/invplan.png"
              alt="Photo 2"
              onClick={() => handleThumbnailClick('photo', 'assets/invplan.png')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/invsports.jpg"
              alt="Photo 2"
              onClick={() => handleThumbnailClick('photo', 'assets/invsports.jpg')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/invevnlwn.jpg"
              alt="Photo 2"
              onClick={() => handleThumbnailClick('photo', 'assets/invevnlwn.jpg')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/invswim.jpg"
              alt="Photo 2"
              onClick={() => handleThumbnailClick('photo', 'assets/invswim.jpg')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/invplot.png"
              alt="Photo 2"
              onClick={() => handleThumbnailClick('photo', 'assets/invplot.png')}
            />
          </div>
        )}
      </div>

      <div className="primecards">
        <div className="descpcards">

          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Redefining Luxurious Living</h5>
              <h6 className="card-subtitle mb-2 text-muted">First 97 Bigha residential project with a golf course located at Dholera-Dhandhuka Link Road, Gujarat.</h6>
            </div>
          </div>

          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Premium Infrastructure for elegant living.</h5>
              <h6 className="card-subtitle mb-2 text-muted">The luxury project features robust infrastructure including gated entry, well paved internal roads, efficient lighting, reliable power and water supply, event lawns, swimming pool, gymnasium, banquet hall, meeting rooms and many more.</h6>
            </div>
          </div>


          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Shopping Complex At Entrance.</h5>
              <h6 className="card-subtitle mb-2 text-muted">Offers convinient access to daily essentials and leisure shopping, a variety of retail stores.</h6>
            </div>
          </div>


          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Sports Zone</h5>
              <h6 className="card-subtitle mb-2 text-muted">The outdoor sports zone offers a diverse range of activities designed to promote health and wellness.</h6>
            </div>
          </div>

          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Limited Population, Unlimited Peace</h5>
              <h6 className="card-subtitle mb-2 text-muted">Experience tranquility with low population density – your perfect retreat.</h6>
            </div>
          </div>
          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Secure Your Slice of Paradise</h5>
              <h6 className="card-subtitle mb-2 text-muted">Selling fast – 300-320 plots already booked! Don’t miss your chance.</h6>
            </div>
          </div>
          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Close to Nature</h5>
              <h6 className="card-subtitle mb-2 text-muted">Immerse yourself in the serene, green oasis promoting carbon neutral environment</h6>
            </div>
          </div>
          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Ideal Investment Opportunity</h5>
              <h6 className="card-subtitle mb-2 text-muted">A prime investment in a serene and rapidly developing area.</h6>
            </div>
          </div>

        </div>
      </div>

      <div className="primelfoot">
        <div className="googlemaps">
      
          <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14762.611116265693!2d72.0842463!3d22.3289678!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395f2919e3e0b34d%3A0xcde42284fc80f811!2sMayur%20Greenz%20by%20Mirrikh%20Infratech!5e0!3m2!1sen!2sin!4v1726308760884!5m2!1sen!2sin" 
          width="600" 
          height="450" 
          style={{ border: 0 }}
          allowfullscreen="" 
          loading="lazy" 
          referrerpolicy="no-referrer-when-downgrade">
          </iframe>
        </div>
        <div className="number">
          <p>Only <span>{plotsLeft}</span> Plots Left</p>
        </div>
        <div className="contactlink">
          <a href="/contact">Book Now!!</a>
        </div>
        <div className="naksha">

        <img class="nakshaimg"  src="assets/innaksha.png" />
        </div>
      </div>
    </>
  );
};

export default Inv;
